import Constant from '@/common/constant/Constant';
import { createNewTicketAPI, saveDraftTicketAPI, createNewAnonymousQaAPI, deleteAllTicketData } from '@/service/ticketService';
import Utils from '@/common/utils/utils';
import { validateErrorTicket, validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';
import { getListProjectExternalDesk, getProjectDeskOn } from '@/service/projectService';
import { getFormListByProject } from '@/service/formManagementService';
import { getFormFromFormListById, getListCustomFiledOfForm, isTicketCountNumber, getFilteredAndSortedForms, unregisterField, updateLimitNumOfTicket } from './TicketHandler';
import { copyFileOfTicketDraftTo, getFormFieldData, handleUploadFilesForTicket } from '@/component/common/layout/addTicket/handler/AddTicketHandler';
import trI18n from '@/common/utils/trI18n';
import { onSubmitCreateInvitationGuestDeskProjectTicket } from './InvitationGuestDeskProjectTicketHandler';
import { isInputAllFieldRequired, isInputValueInCustomForm, updateUsingTicketOfFormListState, getPanelType } from './CreateTicketCommonHandler';
import { TmpHiddenSysFieldInTicketDetail, TmpHiddenSysfieldInCreateTicket, systemField } from '../../../common/constant/SystemField';
import { cloneDeep } from 'lodash';
import { removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import {
    getListCustomerUserInProject
} from '@/service/userService';
import localStorageUtil from '@/common/utils/localStorageUtil';
import { checkDetailTicket } from '../../../service/ticketService';
import { createKibanaDataContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import { createKibanaLogAPI } from '@/service/logKibanaService';
import { updateUserWorkLastForm } from '@/common/utils/ServiceFactoryUtil';
import { buildSnackbarMessage } from '@/component/common/SnackbarMessage';

const externalDeskProjectErrObj = {
    error: true,
    helperText: 'COMMSG001',
}

export const createKibanaLogForCreateQA = (argsAll, API, lastUserAction, setLastUserAction, newTicket, isCreateDraftTicket) => {
    let usingFormName = Utils.convertJSONDataToObject(argsAll.selectedFormInfo.name)?.jp?.text;
    let dataLog = {
        rootCorporationDetail: {
            id: isCreateDraftTicket ? argsAll.corporationDetail.id : argsAll.corporationTarget
        },
        rootProjectDetail: {
            id: isCreateDraftTicket ? argsAll.projectInuseDetail.id : argsAll.projectTarget
        },
        corporationDetail: argsAll.corporationDetail,
        projectDetail: argsAll.projectInuseDetail,
        userDetail: argsAll.userDetail,
        ticketDetail: {
            id: newTicket.id,
            outline: newTicket.outline,
            creator: newTicket.creator,
            usingFormName: usingFormName,
            createdAt: newTicket.createdAt,
        },
        metaData: {
            formDetailId: argsAll.selectedForm,
            ticketType: argsAll.createTicketType
        },
        ticketCreationScreen: LogKibanaConstant.TICKET_CREATION_SCREEN.SOLUTIONDESK
    }

    let logKibanaData = createKibanaDataContentOperation(
        lastUserAction,
        dataLog
    );
    let param = {
        logType: LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD,
        logKibanaData: logKibanaData
    };
    createKibanaLogAPI(API, param);
    setLastUserAction(null);
}

export const onSubmitCreateQaTicket = async (argsAll, formData, panelId, panelType, tabId, forceCreate = false) => {
    if (!argsAll.projectTarget || !argsAll.selectedForm || !argsAll.projectInuseDetail) {
        return;
    }
    argsAll.setIsLoading(true);
    if (argsAll.isDraft) {
        let {status: currentStatusTicket} = await checkDetailTicket(argsAll.API, argsAll.detailTicket.id);
        if (currentStatusTicket === Constant.TICKET_DELETED_STATUS.REMOVED) {
            argsAll.setIsLoading(false);
            argsAll.setIsOpenPopupError(true);
            return;
        }
    }

    const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);

    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }


    let lastUserAction = LogKibanaConstant.CONTENT_OPERATION_ACTION.ADD;
    argsAll.setLastUserAction(lastUserAction)
    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    // Invite guest desk logic
    if (argsAll.createTicketType === Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT) {
        // Validate max general user
        let limitValue = argsAll.corporationDetail?.limitValue;
        if (limitValue && limitValue?.numOfGeneralUser >= limitValue?.maxNumOfGeneralUser) {
            argsAll.setErorsQATicket(
                'maxGeneralId',
                { type: 'manual', message: trI18n('USER03MSG007') },
                { shouldFocus: true }
            );
            argsAll.setIsLoading(false);
            return;
        }

        const newInviteTicket = await onSubmitCreateInvitationGuestDeskProjectTicket(
            argsAll,
            formData,
            argsAll.userDetail,
            panelId,
            argsAll.corporationDetail,
            argsAll.selectedFormInfo,
            argsAll.enqueueSnackbar,
            tabId,
            panelType,
            fields,
            forceCreate,
            lastUserAction
        );
        return;
    }

    let requestBody = {};
    let affiliationOrganization = formData.corporationTarget ? formData.corporationTarget : argsAll.corporationTarget;
    let affiliationProject = formData.projectTarget ? formData.projectTarget : argsAll.projectTarget;
   
    const statusField = argsAll.fieldListData.find((fieldData) => fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW);
    let status = '';
    if(!Utils.isEmptyObject(statusField)){
        status = statusField.fieldId;
    }

    let customer;
    if (argsAll.projectInuseDetail.type === Constant.PROJECT_TYPE.BASE || argsAll.projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER) {
        customer = argsAll.userDetail.id;
    } else {
        customer = argsAll.projectInuseDetail.id;
    }
    
    if(!affiliationOrganization) {
        affiliationOrganization = argsAll.corporationDetail.id;
    }
    formData.affiliationOrganization = affiliationOrganization;

    // ticketType
    let ticketType = Constant.TICKET_TYPE.QA;

    // QA from Customer prj and Guest prj => ticketType == QA
    if (argsAll.projectInuseDetail.type !== Constant.PROJECT_TYPE.CUSTOMER && !Utils.isProjectGuest(argsAll.projectInuseDetail)) {
        if (argsAll.corporationId === affiliationOrganization) {
            ticketType = Constant.TICKET_TYPE.INTERNAL_QA;
        } else {
            ticketType = Constant.TICKET_TYPE.EXTERNAL_QA;
        }
    }

    // validate
    if (validateErrorTicket(argsAll, fields)) {
        argsAll.setIsLoading(false);
        return;
    }
    let selectedForm = formData.selectedForm ? formData.selectedForm : argsAll.selectedForm,
        newTicket = {},
        inviteAndApproveStatus = {};
    let listB2CInProj = [];
    let infoB2CInProj = {};
    if (argsAll.projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER) {
        listB2CInProj = await getListCustomerUserInProject(
            argsAll.API,
            argsAll.projectTarget
        );

        infoB2CInProj = listB2CInProj.find((item) => {
            return item.id2 === customer && item.active === Constant.ACTIVE_FLAG.ACTIVE;
        });
    }

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };
    
    uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );
    // External desk request invitation
    if (argsAll.createTicketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK) {
        if (
            Utils.isEmptyObject(argsAll.externalDeskRequestProject) ||
            !argsAll.externalDeskRequestProject?.value ||
            !argsAll.externalDeskRequestProject?.corporationId
        ) {
            let errObj = {...externalDeskProjectErrObj};
            errObj.helperText = 'COMM01MSG11';
            argsAll.setExternalDeskProjectErr(errObj);
            argsAll.setIsLoading(false);
            return;
        }
        affiliationOrganization = argsAll.externalDeskRequestProject.corporationId;
        affiliationProject = argsAll.externalDeskRequestProject.value;
        formData.projectTarget = argsAll.externalDeskRequestProject.value;
        ticketType = Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK;
        inviteAndApproveStatus.invitationFlag = Constant.INVITATION_FLAG.WAITING_APPROVE;
        inviteAndApproveStatus.approveFlag = Constant.APPROVE_FLAG.INPROCESS;
    }

    if (Utils.isEmptyObject(infoB2CInProj) && argsAll.createTicketType === Constant.TICKET_TYPE.QA && argsAll.projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER) {
        let anonymousUserInfo = {
            mailAddress : argsAll?.userDetail?.mail,
            firstName: Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                argsAll?.userDetail?.firstName
            ),
            lastName: Utils.getTextByLanguage(
                Constant.LANGUAGE_TYPE.JP,
                argsAll?.userDetail?.lastName
            )
        };
        requestBody = {
            createAnonymousQaRequestDto: {
                liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
                public: Constant.TICKET_PUBLIC.PUBLIC,
                outline: formData?.outline,
                corporationOrigin: argsAll.corporationDetail.id,
                description: formData?.description,
                createUserId: argsAll.userDetail.id,
                projectOrigin: argsAll.projectInuseDetail.id,
                anonymousQaStatus: Constant.ANONYMOUS_TICKET_STATUS.WAITING_APPROVE,
                projectTarget: [formData.projectTarget],
                corporationTarget: formData.corporationTarget ? formData.corporationTarget : argsAll.corporationDetail.id,
                ticketType: Constant.TICKET_TYPE.QA,
                anonymousUserInfo: JSON.stringify(anonymousUserInfo),
                affiliationOrganization,
                affiliationProject,
                type: selectedForm,
                customer,
                creator: Constant.ANONYMOUS_USER_ID,
                status,
                fields,
                fileListSuccess: uploadFileS3Result.fileListSuccess,
                suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
                ...draftTicketInfo
            },
        };
        let result = await createNewAnonymousQaAPI(argsAll.API, requestBody);
        newTicket = result?.data?.createAnonymousQa
    } else {
        requestBody = {
            createTicketRequestDto: {
                liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
                public: Constant.TICKET_PUBLIC.PUBLIC,
                outline: formData?.outline,
                corporationOrigin: argsAll.corporationDetail.id,
                description: formData?.description,
                createUserId: argsAll.userDetail.id,
                projectOrigin: argsAll.projectInuseDetail.id,
                projectTarget: [formData.projectTarget],
                corporationTarget: formData.corporationTarget ? formData.corporationTarget : argsAll.corporationDetail.id,
                ticketType,
                type: selectedForm,
                affiliationOrganization,
                affiliationProject,
                status,
                customer,
                fields,
                fileListSuccess: uploadFileS3Result.fileListSuccess,
                suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),

                // External desk request
                ...inviteAndApproveStatus,
                ...draftTicketInfo
            },
        };
        newTicket = await createNewTicketAPI(argsAll.API, requestBody);
    }

    if (!newTicket?.id) {
        if (!newTicket?.createTicketStatus && newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            // Reload
            argsAll.setIsLoading(false);
            argsAll.setIsOpenModalReloadPage(true);
            return;
        }

        let errList = newTicket?.errors;
        let msgCode = !Utils.isEmptyArray(errList) ? errList[0]?.message : '';
        if (msgCode) {
            argsAll.enqueueSnackbar(buildSnackbarMessage(msgCode), {
                variant: 'error',
                autoHideDuration: 3000,
            });
        }

        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_QA,
        formId: selectedForm,
        projectTargetId: formData.projectTarget,
        corpTargetId: formData.corporationTarget ? formData.corporationTarget : argsAll.corporationDetail.id
    }

    if (argsAll.createTicketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK) {
        // code later
        dataUpdateLastForm.typeLastTicket = Constant.TYPE_LAST_FORM.LAST_FORM_INVITED_QA;
    }
    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    argsAll.setIsLoading(false);
    createKibanaLogForCreateQA(argsAll, argsAll.API, lastUserAction, argsAll.setLastUserAction, newTicket);

    updateUsingTicketOfFormListState(argsAll.currentCorporationFormList, argsAll.setCurrentCorporationFormList, argsAll.selectedForm, newTicket);
    removePanelInitData(panelId, tabId, argsAll.panelInitData, argsAll.setPanelInitData);

    argsAll.updatePanelAfterCreateTicket({
        panelId: panelId,
        tabId: tabId,
        panelType: panelType,
        ticketId: newTicket?.id,
        ticketOutline: newTicket?.outline,
        API: argsAll.API
    });

    if(isTicketCountNumber(ticketType) && affiliationOrganization === argsAll.corporationDetail.id) {
        updateLimitNumOfTicket(argsAll);
    }
    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-SEND-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });

    return;
};


/**
 * getHelpDeskListOfProject
 * @param {*} API 
 * @param {*} projectInuseDetail 
 * @returns 
 */
export const getHelpDeskListOfProject = async (API, corporationId, projectInuseDetail) => {
    let internalHelpDeskList = [];
    let externalHelpDeskList = [];

    if (Utils.isProjectGuest(projectInuseDetail)) {
        if (!projectInuseDetail.projectInvite) {
            return { internalHelpDeskList, externalHelpDeskList };
        }

        externalHelpDeskList = await getListProjectExternalDesk(API, projectInuseDetail, true);
        externalHelpDeskList = Utils.sortByCreatedAtDesc(externalHelpDeskList);

        return { internalHelpDeskList, externalHelpDeskList };
    } else {
        [internalHelpDeskList, externalHelpDeskList] = await Promise.all([
            getProjectDeskOn(API, corporationId),
            getListProjectExternalDesk(API, projectInuseDetail, true)
        ]);

        // Remove prj inuse in list internal
        internalHelpDeskList = Utils.removeItemInArrayById(
            projectInuseDetail.id,
            internalHelpDeskList
        );

        // Sort
        internalHelpDeskList = Utils.sortByCreatedAtDesc(internalHelpDeskList);
        externalHelpDeskList = Utils.sortByCreatedAtDesc(externalHelpDeskList);

        return { internalHelpDeskList, externalHelpDeskList };
    }
}

export const handleOnchangeProject = async(e, argsAll, targetProjectId = '') => {
    let projectTargetPrev = argsAll.projectTarget;
    let projectTargetSelected = e?.target?.dataset?.value;
    if (!projectTargetSelected && targetProjectId) {
        projectTargetSelected = targetProjectId;
    }
    if (!projectTargetSelected || projectTargetSelected === argsAll.projectTarget) {
        return;
    }

    if (isInputFormValue(argsAll)) {
        argsAll.setDialogConfirmType(Constant.CREATE_TICKET_DIALOG_CONFIRM_TYPE.HELPDESK);
        if(Utils.isEmpty(argsAll.draftData)){
            argsAll.setIsConfirmChangeDeskOrForm(true);
        }
        else{
            argsAll.setIsOpenDialogQAConfirmChangeTicketType(true);
        }
        argsAll.setSelectedProjectChange(projectTargetSelected);
    } else {
        submitOnchangeProject(projectTargetSelected, argsAll);
    }

    argsAll.setIsOpenSelectProject(false);
    if(projectTargetPrev !== projectTargetSelected && argsAll.isDraft){
        argsAll.setIsEdited(true);
    }
}

/**
 * 
 * @param {*} projectTargetSelected 
 * @param {*} argsAll 
 * @returns 
 */
const getInternalHelpDeskListByProjectTarget = (projectTargetSelected, argsAll) => {
    let indexSelectedProjectInListInternal = Utils.findIndexInArrayById(
        projectTargetSelected,
        argsAll.internalHelpDeskList
    );
    
    if (indexSelectedProjectInListInternal !== -1) {
        return argsAll.internalHelpDeskList[indexSelectedProjectInListInternal];
    }
    if(argsAll.isDraft && !Utils.isEmptyArray(argsAll.draftInternalHelpDeskList)){
        let indexDraftSelectedProjectInListInternal = Utils.findIndexInArrayById(
            projectTargetSelected,
            argsAll.draftInternalHelpDeskList
        );

        if (indexSelectedProjectInListInternal === -1){
            return argsAll.draftInternalHelpDeskList[indexDraftSelectedProjectInListInternal];
        }
    }

    return {};
}

/**
 * 
 * @param {*} projectTargetSelected 
 * @param {*} argsAll 
 * @returns 
 */
const getExternalHelpDeskListByProjectTarget = (projectTargetSelected, argsAll) => {
    let indexSelectedProjectInListExternal = Utils.findIndexInArrayById(
        projectTargetSelected,
        argsAll.externalHelpDeskList
    );
    
    if (indexSelectedProjectInListExternal !== -1) {
        return argsAll.externalHelpDeskList[indexSelectedProjectInListExternal];
    }

    if(argsAll.isDraft && !Utils.isEmptyArray(argsAll.draftExternalHelpDeskList)){
        let indexDraftSelectedProjectInListExternal = Utils.findIndexInArrayById(
            projectTargetSelected,
            argsAll.draftExternalHelpDeskList
        );
        if (indexSelectedProjectInListExternal === -1){
            return argsAll.draftExternalHelpDeskList[indexDraftSelectedProjectInListExternal];
        }
    }
    return {};
}

/**
 * 
 * @param {*} projectTargetSelected 
 * @param {*} argsAll 
 * @returns 
 */
export const getProjectTargetSelectedData = (projectTargetSelected, argsAll) => {
    if(!Utils.isEmptyObject(getInternalHelpDeskListByProjectTarget(projectTargetSelected, argsAll))){      
        return getInternalHelpDeskListByProjectTarget(projectTargetSelected, argsAll);
    }

    if(!Utils.isEmptyObject(getExternalHelpDeskListByProjectTarget(projectTargetSelected, argsAll))){       
        return getExternalHelpDeskListByProjectTarget(projectTargetSelected, argsAll);
    }
    return {};
}

/**
 * submitOnchangeProject helpdesk
 * @param {*} e 
 * @param {*} argsAll 
 * @returns 
 */
export const submitOnchangeProject = async(projectTargetSelected, argsAll, isKeepLoading=false) => {
    if (!Utils.isEmptyArray(argsAll.fieldListData)) {
        unregisterField(argsAll.fieldListData, argsAll.unregisterCreateQaTicket);
        // Reset attact file
        argsAll.setValueCreateQaTicket(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, []);
        argsAll.setFileUploadList([]);
    }

    // Request desk
    if (projectTargetSelected === Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST) {
        argsAll.setRequestType(Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST);
        unregisterField(argsAll.fieldListData, argsAll.unregisterCreateQaTicket);
        argsAll.setFiledListData([]);
        argsAll.setFormList([]);
        argsAll.setSelectedForm('');
        argsAll.setSelectedFormInfo({});
        argsAll.setProjectTarget(Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST);
        argsAll.setCorporationTarget('');
        argsAll.setValueCreateQaTicket('');
        if(argsAll?.detailTicket?.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK){
            let projectTargetInfo = Utils.convertJSONDataToObject(argsAll.draftData.externalProjectInfo).projectCustomer;
            let corpTargetInfo = Utils.convertJSONDataToObject(argsAll.draftData.externalProjectInfo).corporationCustomer;
            if(!Utils.isEmptyObject(projectTargetInfo?.name) && !Utils.isEmptyObject(corpTargetInfo?.name)){
                let title = `${Utils.getTextByLanguage(
                    Constant.LANGUAGE_TYPE.JP,
                    projectTargetInfo?.name
                )}(${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, corpTargetInfo?.name)})`;

                argsAll.setExternalDeskRequestKeyword(title);

                argsAll.setExternalDeskRequestProject({
                    corporationId: corpTargetInfo.id,
                    title: title,
                    value: projectTargetInfo.id
                });
            }
        }
        if(!isKeepLoading){
            argsAll.setIsLoading(false);
        }
    } else {
        argsAll.setCreateTicketType(Constant.TICKET_TYPE.QA);
        argsAll.setRequestType('');
        let projectTargetSelectedData = getProjectTargetSelectedData(projectTargetSelected, argsAll);
        if (Utils.isEmptyObject(projectTargetSelectedData)) {
            return;
        }

        // Update state and set form value prj/corp
        if(!isKeepLoading){
            argsAll.setIsLoading(true);
        }
        argsAll.setProjectTarget(projectTargetSelectedData.id);
        argsAll.setCorporationTarget(projectTargetSelectedData.affiliationOrganization);
        argsAll.setValueCreateQaTicket('projectTarget', projectTargetSelectedData.id);
        argsAll.setValueCreateQaTicket('corporationTarget', projectTargetSelectedData.affiliationOrganization);
        argsAll.setValueCreateQaTicket('selectedForm', '');
        argsAll.setValueCreateQaTicket('fileUploadList', []);
        argsAll.setFiledListData([]);

        let listFormQAOfSelectedProject = await getListFormQAOfProject(argsAll.API, projectTargetSelectedData.affiliationOrganization, projectTargetSelectedData.id);
        argsAll.setFormList(listFormQAOfSelectedProject);
        argsAll.setSelectedForm('');
        argsAll.setSelectedFormInfo({});
        if(!isKeepLoading){
            argsAll.setIsLoading(false);
        }
    }
}


/**
 * getListFormQAOfProject with sort by order
 * @param {*} API 
 * @param {*} corporationId 
 * @param {*} projectId 
 * @returns 
 */
export const getListFormQAOfProject = async (API, corporationId, projectId) => {
    let formQAList = [];

    const formOfProjectList = await getFormListByProject(
        API,
        corporationId,
        projectId
    );

    formQAList = getFilteredAndSortedForms(formOfProjectList, projectId, Constant.FORM_TYPE.FORM_REQ_QA);
    return formQAList;
}


export const handleOnchangeForm = async (e, argsAll, targetFormId = '') => {
    let selectedFormPrev = argsAll.selectedForm;
    let selectedFormId = e?.target?.dataset?.value;
    if (!selectedFormId && targetFormId) {
        selectedFormId = targetFormId;
    }
    
    if (selectedFormId === argsAll.selectedForm) {
        return;
    }

    if (isInputFormValue(argsAll)) {
        argsAll.setDialogConfirmType(Constant.CREATE_TICKET_DIALOG_CONFIRM_TYPE.FORM);
        if(Utils.isEmpty(argsAll.draftData)){
            argsAll.setIsConfirmChangeDeskOrForm(true);
        }
        else{
            argsAll.setIsOpenDialogQAConfirmChangeFormType(true);
        }
        argsAll.setSelectedFormChange(selectedFormId);
    } else {
        submitOnchangeFormQA(selectedFormId, argsAll);
    }

    argsAll.setIsOpenSelectForm(false);
    if(selectedFormPrev !== selectedFormId && argsAll.isDraft){
        argsAll.setIsEdited(true);
    }
}

/**
 * submitOnchangeFormQA
 * @param {*} selectedFormId
 * @param {*} argsAll 
 * @returns 
 */
export const submitOnchangeFormQA = async (selectedFormId, argsAll, isKeepLoading=false, formDetail, initFieldListData) => {
    // Reset old value of form, set new form id
    if(!isKeepLoading){
        argsAll.setIsLoading(true);
    }
    if (!Utils.isEmptyArray(argsAll.fieldListData)) {
        unregisterField(argsAll.fieldListData, argsAll.unregisterCreateQaTicket, argsAll.resetValuesCreateQaTicket);

        // Reset attact file
        argsAll.setValueCreateQaTicket(Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME, []);
        argsAll.setFileUploadList([]);
        
        // Reset current panel init data
        let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
        delete cloneCurrentPanelInitData.formData;
        argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
        argsAll.setTriggerSaveFormData(Date.now().toString());
        argsAll.setIsEdited(true);
    }
    argsAll.setSelectedForm(selectedFormId);

    let selectedFormDetail = formDetail;
    if (!selectedFormDetail || Utils.isEmptyObject(selectedFormDetail)) {
        selectedFormDetail = await getFormFromFormListById(selectedFormId);
    }

    let fieldOrderInForm = {};
    let formStructure = Utils.convertJSONDataToObject(selectedFormDetail.structure);
    if (!Utils.isEmptyObject(formStructure)) {
        for (const [structureKey, structureValue] of Object.entries(formStructure)) {
            if (structureKey && structureValue && structureValue.hasOwnProperty('field')) {
                fieldOrderInForm[structureValue['field']] = parseInt(structureKey);
            }
        }
    }

    if (!Utils.isEmptyObject(selectedFormDetail)) {
        argsAll.setSelectedFormInfo(selectedFormDetail);
        let getFieldListResult = [];

        if (!Utils.isEmptyArray(initFieldListData)) {
            getFieldListResult = cloneDeep(initFieldListData);
        } else {
            const customFieldList = await getListCustomFiledOfForm(
                formStructure,
                argsAll.API,
                selectedFormDetail.affiliationOrganization
            );
            getFieldListResult = getFormFieldData(formStructure, customFieldList);
        }

        getFieldListResult = getFieldListResult.filter(
            (x) =>
                Number(x.structure.publicForCustomer) !==
                    Constant.SETTING_PUBLIC_FOR_CUSTOMER.HIDE || x.type === Constant.FORM_TYPE.FIELD_WORKFLOW
        );
        getFieldListResult = Array.from(getFieldListResult, (field) => {
            if (
                Number(field.structure.publicForCustomer) ===
                Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW
            ) {
                field.structure.required = false;
            }

            if (['guestOrg', 'guestProject'].includes(field.sysField)) {
                field.structure.required = true;
            }
            return field;
        });
         // filer share range of field
        if (selectedFormDetail.definition !== Constant.FORM_DEFINITION.SYSTEM) {
            getFieldListResult = getFieldListResult.filter(x => {
                // sys field auto pass
                if (
                    (x.definition = Constant.FORM_DEFINITION.SYSTEM) ||
                    x.type === Constant.FORM_TYPE.FIELD_WORKFLOW
                ) {
                    return true;
                }

                // get corporation of form
                let currentCorporationDetailId = '';
                if (
                    argsAll?.typeOfTicket === Constant.TICKET_TYPE.NOTICE ||
                    argsAll?.typeOfTicket === Constant.TICKET_TYPE.DELEGATE
                ) {
                    currentCorporationDetailId = argsAll?.corporationDetail?.id
                        ? argsAll?.corporationDetail?.id
                        : localStorageUtil.getAffiliationOrganization();
                } else {
                    currentCorporationDetailId = argsAll?.corporationTarget;
                }

                // field is belong corporation
                if (x.affiliationOrganization === currentCorporationDetailId) {
                    return true;
                }

                // field is shared
                if (currentCorporationDetailId) {
                    let shareRangeOfField = Utils.convertJSONDataToObject(x.shareRange)
                        ? []
                        : Utils.convertJSONDataToObject(x.shareRange);
                    return shareRangeOfField?.includes(currentCorporationDetailId);
                }
                return true;
            });

            // filter field inactive
            getFieldListResult = getFieldListResult.filter(field => {
                if (
                    (field.definition === Constant.FORM_DEFINITION.SYSTEM && field.sysField !== 'outline')||
                    field.type === Constant.FORM_TYPE.FIELD_WORKFLOW
                ) {
                    return true;
                }
                let usingProjectOfField = Utils.convertJSONDataToObject(field.usingProjects);
                return usingProjectOfField?.includes(selectedFormDetail.affiliationProject);
            });
        }

        getFieldListResult = [...getFieldListResult]
            .filter(field => {
                if (!field.sysField || !TmpHiddenSysfieldInCreateTicket.includes(field.sysField))
                    return true;
                return false;
            })
            .filter(
                field =>
                    field?.usingProjects?.includes(selectedFormDetail?.affiliationProject) ||
                    selectedFormDetail?.definition === Constant.FORM_DEFINITION.SYSTEM
            )
            .sort((a, b) => {
                // attachment always at bottom
                if (a.sysField === 'attachments') return 1;
                if (b.sysField === 'attachments') return -1;

                if (!Utils.isEmptyObject(fieldOrderInForm)) {
                    return fieldOrderInForm[a.id] - fieldOrderInForm[b.id];
                }

                return 1;
            });

        if (!Utils.isEmptyArray(initFieldListData)) {
            let newListField = [];
            getFieldListResult.forEach(fieldData => {
                if (fieldData.publicForCustomer !== Constant.SETTING_PUBLIC_FOR_CUSTOMER.HIDE) {
                    let defaultValue;
                    if (fieldData.type === Constant.FORM_TYPE.FIELD_TAG || fieldData.structure?.UI === Constant.FIELD_UI.DROP_FILE) {
                        defaultValue = [];
                    } else {
                        defaultValue = '';
                    }

                    if (fieldData.defaultValue) {
                        defaultValue = fieldData.defaultValue
                    } else if (fieldData.value) {
                        defaultValue = fieldData.value
                    }

                    let fieldDataTmp = {
                        ...fieldData,
                        defaultValue
                    };
                    if (argsAll.isDraftMode) {
                        fieldDataTmp.structure.publicForCustomer = Constant.SETTING_PUBLIC_FOR_CUSTOMER.EDITABLE;
                    }
                    if (fieldDataTmp.publicForCustomer) {
                        fieldDataTmp.structure.publicForCustomer = fieldDataTmp.publicForCustomer;
                    }
                    if (
                        Number(fieldDataTmp.publicForCustomer) ===
                        Constant.SETTING_PUBLIC_FOR_CUSTOMER.ONLY_VIEW
                    ) {
                        fieldDataTmp.structure.required = false;
                    }
                    newListField.push(fieldDataTmp);
                }
            });

            argsAll.setFiledListData([...newListField]);
        } else {
            argsAll.setFiledListData([...getFieldListResult]);
        }

        // Update isCreateExternalDeskRequest and create ticket type
        switch (selectedFormDetail.type) {
            case Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK:
                argsAll.setCreateTicketType(Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK);
                break;
            case Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK:
                argsAll.setCreateTicketType(Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT);
                break;
            default:
                if(!Utils.isEmptyObject(argsAll.draftData)){
                    argsAll.setSelectedForm(selectedFormId);
                }
                argsAll.setCreateTicketType(Constant.TICKET_TYPE.QA);
                break;
        }
    }

    if(!isKeepLoading){
        argsAll.setIsLoading(false);
    }
};

/**
 * getProjectLabel
 * label display to select
 * @param {*} project 
 * @param {*} corporationDetail 
 * @returns 
 */
export const getProjectLabel = (project, corporationDetail) => {
    if (Utils.isEmptyObject(project)) return '';
    
    let projectName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, project.name);

    let corporationName = '';
    if (project.affiliationOrganization === corporationDetail.id) {
        corporationName = Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            corporationDetail.name
        );
    } else {
        corporationName = Utils.getTextByLanguage(
            Constant.LANGUAGE_TYPE.JP,
            project.corporationData.name
        );
    }

    return `${projectName} (${corporationName})`;
};

/**
 * get name of internal project
 * @param {*} project 
 * @returns projectName
 */
export const getProjectInternalLabel = (project) => {
    if (Utils.isEmptyObject(project)) return '';
    
    let projectName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, project.name);
    return `${projectName}`;
};

/**
 * handleCloseSelectProject
 * @param {*} argsAll 
 */
export const handleCloseSelectProject = (argsAll) => {
    argsAll.setIsOpenSelectProject(false);
}


/**
 * handleOpenSelectProject
 * @param {*} argsAll 
 */
export const handleOpenSelectProject = (argsAll) => {
    argsAll.setIsOpenSelectProject(true);
}

/**
 * handleCloseSelectForm
 * @param {*} argsAll 
 */
 export const handleCloseSelectForm = (argsAll) => {
    argsAll.setIsOpenSelectForm(false);
}


/**
 * handleOpenSelectForm
 * @param {*} argsAll 
 */
export const handleOpenSelectForm = (argsAll) => {
    argsAll.setIsOpenSelectForm(true);
}

/**
 * isInputFormValue
 * @param {*} argsAll 
 * @returns 
 */
export const isInputFormValue = (argsAll) => {
    if (
        !argsAll.selectedForm ||
        Utils.isEmptyArray(argsAll.fieldListData) ||
        Utils.isEmptyObject(argsAll.selectedFormInfo)
    ) {
        return false;
    }

    let externalDeskRequestProject = argsAll?.externalDeskRequestProject
        ? argsAll?.externalDeskRequestProject
        : {};

    let isInputData = false;

    // is upload file
    let uploadList = '';
    if (
        [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
            argsAll?.ticketType
        )
    ) {
        uploadList = argsAll.getValuesCreateKnowledgeTicket('fileUploadList')
    }
    else {
        uploadList = argsAll?.getValuesCreateQaTicket('fileUploadList');
    }

    if (!Utils.isEmptyArray(uploadList)) {
        return true;
    }

    for (const field of argsAll.fieldListData) {
        let fieldId = field.id;
        let fieldValue = '';

        if (
            [Constant.TICKET_TYPE.KNOWLEDGE, Constant.TICKET_TYPE.MASTER_KNOWLEDGE].includes(
                argsAll?.ticketType
            )
        ) {
            fieldValue = argsAll.getValuesCreateKnowledgeTicket(fieldId)
        }
        else {
            fieldValue = argsAll?.getValuesCreateQaTicket(fieldId);
        }

        if (
            (argsAll.selectedFormInfo.definition === Constant.FORM_DEFINITION.SYSTEM &&
                isInputValueInSystemForm(
                    argsAll.selectedFormInfo,
                    field,
                    fieldValue,
                    externalDeskRequestProject
                )) ||
            ([Constant.FORM_DEFINITION.USER, Constant.FORM_DEFINITION.MASTER, Constant.FORM_DEFINITION.SYSTEM_MASTER_FIELD].includes(argsAll.selectedFormInfo.definition) &&
                isInputValueInCustomForm(field, fieldValue))
        ) {
            isInputData = true;
            break;
        }
    }

    return isInputData;
};


/**
 * isInputValueInSystemForm
 * validate is input value in system form
 * @param {*} formInfo 
 * @param {*} field 
 * @param {*} fieldValue 
 * @param {*} externalDeskRequestProject 
 * @returns 
 */
const isInputValueInSystemForm = (formInfo, field, fieldValue, externalDeskRequestProject) => {
    let firstItemFieldQaCategory = systemField.find(fieldSystem => fieldSystem.affiliationField === 'field_qa_category' && fieldSystem.structure.no === 1);
    let firstItemFieldQaCategoryTitle = firstItemFieldQaCategory?.name?.jp?.text;
    let systemFieldId = field.sysField;
    let isInputValue = false;
    switch (formInfo.type) {
        // Default QA
        case Constant.FORM_TYPE.FORM_REQ_QA:
            if (systemFieldId === 'field_qa_category') {
                if (
                    fieldValue.length !== 1 ||
                    fieldValue[0].title !== firstItemFieldQaCategoryTitle
                ) {
                    isInputValue = true;
                }
            } else if (fieldValue) {
                isInputValue = true;
            }
            break;

        case Constant.FORM_TYPE.FORM_REQ_INVITE_GUESTDESK:
            if (fieldValue) {
                fieldValue = fieldValue.trim();
            }

            if (
                (systemFieldId === 'outline' &&
                    fieldValue !== Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.OUTLINE) ||
                (systemFieldId === 'category' &&
                    fieldValue !==
                        Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.CATEGORY) ||
                (systemFieldId === 'description' &&
                    fieldValue !==
                        Constant.CREATE_TICKET_DEFAULT_VALUE.INVITE_GUESTDESK.DESCRIPTION) ||
                (!['outline', 'category', 'description'].includes(systemFieldId) && fieldValue)
            ) {
                isInputValue = true;
            }

            break;

        case Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK:
            if (fieldValue) {
                fieldValue = fieldValue.trim();
            }

            if (
                (systemFieldId === 'outline' &&
                    fieldValue !==
                        Constant.CREATE_TICKET_DEFAULT_VALUE.EXTERNAL_DESK_REQUEST.OUTLINE) ||
                (systemFieldId === 'category' &&
                    fieldValue !==
                        Constant.CREATE_TICKET_DEFAULT_VALUE.EXTERNAL_DESK_REQUEST.CATEGORY) ||
                (systemFieldId === 'description' && fieldValue) ||
                !Utils.isEmptyObject(externalDeskRequestProject)
            ) {
                isInputValue = true;
            }

            break;
        default:
            break;
    }

    return isInputValue;
};

/**
 * onSubmitSaveDraftQaTicket
 * @param {*} argsAll 
 * @param {*} formData 
 * @param {*} panelId 
 * @param {*} panelType 
 * @param {*} tabId 
 * @returns 
 */
export const onSubmitSaveDraftQaTicket = async (argsAll, formData, panelId, panelType, tabId) => {
    if (!argsAll.projectTarget || !argsAll.selectedForm) {
        return;
    }
    argsAll.setIsLoading(true);
    if (argsAll.isDraft) {
        let {status: currentStatusTicket} = await checkDetailTicket(argsAll.API, argsAll.detailTicket.id);
        if (currentStatusTicket === Constant.TICKET_DELETED_STATUS.REMOVED) {
            argsAll.setIsOpenPopupError(true);
            return;
        }
    }

    const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);
    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    
    let newTicket
    switch (argsAll.createTicketType) {
        case Constant.TICKET_TYPE.QA:
            newTicket = await submitSaveDraftTicketQA(argsAll, formData, panelId, panelType, tabId);
            break;
        case Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT:
            newTicket = await submitSaveDraftTicketInviteGuestDesk(argsAll, formData, panelId, panelType, tabId);
            break;
        case Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK:
            newTicket = await submitSaveDraftTicketExternalDeskRequest(argsAll, formData, panelId, panelType, tabId);
            break;
        default:
            break;
    }

    if (argsAll.createTicketType === Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT) {
        newTicket.outline = trI18n('USER04P007');
    }

    if (newTicket?.id) {
        if (argsAll?.setDisplayMode) {
            argsAll?.setDisplayMode(Constant.DISPLAY_MODE.VIEW);
        }
        argsAll.updatePanelInitData(panelId, tabId, null, argsAll.setPanelInitData, 'isEditedData', false);
        argsAll.setTriggerSaveFormData(Date.now().toString());
        argsAll.updatePanelAfterCreateTicket({
            panelId: panelId,
            tabId: tabId,
            panelType: panelType,
            ticketId: newTicket?.id,
            ticketOutline: newTicket?.outline,
            API: argsAll.API,
            isDraft: true
        });
    }

    argsAll.setIsEdited(false);
    argsAll.setIsLoading(false);
    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-SAVE-DRAFT-TICKET-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    if(argsAll?.isCloseTabAction) {
        argsAll.setIsCloseTabAction(false);
        argsAll.closePanelTab({
            event: null,
            panelType: getPanelType(argsAll.panelList, argsAll.panelId),
            panelId: argsAll.panelId,
            tabId: argsAll.tabId
        });
        argsAll.hideLoadingMouse();
    }
};


/**
 * submitSaveDraftTicketQA
 * submit save draft ticket QA
 * @param {*} argsAll 
 * @param {*} formData 
 * @param {*} panelId 
 * @param {*} panelType 
 * @param {*} tabId 
 * @returns 
 */
const submitSaveDraftTicketQA = async (argsAll, formData, panelId, panelType, tabId) => {
    let requestBody = {};
    let affiliationOrganization = formData.corporationTarget ? formData.corporationTarget : argsAll.corporationTarget;
    if(!affiliationOrganization) {
        affiliationOrganization = argsAll.corporationDetail.id;
    }
    formData.affiliationOrganization = affiliationOrganization;

    let affiliationProject = formData.projectTarget ? formData.projectTarget : argsAll.projectTarget;
    const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);
    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    const statusField = argsAll.fieldListData.find((fieldData) => fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW);
    let status = '';
    if(!Utils.isEmptyObject(statusField)){
        status = statusField.fieldId;
    }

    let customer;
    if (argsAll.projectInuseDetail.type === Constant.PROJECT_TYPE.BASE || argsAll.projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER) {
        customer = argsAll.userDetail.id;
    } else {
        customer = argsAll.projectInuseDetail.id;
    }

    // ticketType
    let ticketType = Constant.TICKET_TYPE.QA;

    if (argsAll.projectInuseDetail.type !== Constant.PROJECT_TYPE.CUSTOMER && !Utils.isProjectGuest(argsAll.projectInuseDetail)) {
        if (argsAll.corporationId === affiliationOrganization) {
            ticketType = Constant.TICKET_TYPE.INTERNAL_QA;
        } else {
            ticketType = Constant.TICKET_TYPE.EXTERNAL_QA;
        }
    }

    let selectedForm = formData.selectedForm ? formData.selectedForm : argsAll.selectedForm;

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    requestBody = {
        createTicketRequestDto: {
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.DRAFT,
            outline: formData?.outline,
            corporationOrigin: argsAll.corporationDetail.id,
            description: formData?.description,
            createUserId: argsAll.userDetail.id,
            projectOrigin: argsAll.projectInuseDetail.id,
            projectTarget: [formData.projectTarget],
            corporationTarget: formData.corporationTarget ? formData.corporationTarget : argsAll.corporationDetail.id,
            ticketType,
            type: selectedForm,
            affiliationOrganization,
            affiliationProject,
            status,
            customer,
            fields,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            ...draftTicketInfo
        },
    };
    
    const newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        if (!newTicket?.createTicketStatus && newTicket?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            // Reload
            argsAll.setIsLoading(false);
            argsAll.setIsOpenModalReloadPage(true);
            return;
        }
        
        let errList = newTicket?.errors;
        let msgCode = !Utils.isEmptyArray(errList) ? errList[0]?.message : '';
        if (msgCode) {
            argsAll.enqueueSnackbar(buildSnackbarMessage(msgCode), {
                variant: 'error',
                autoHideDuration: 3000,
            });
        }

        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_QA,
        formId: selectedForm,
        projectTargetId: formData.projectTarget,
        corpTargetId: formData.corporationTarget ? formData.corporationTarget : argsAll.corporationDetail.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    return newTicket;
}

/**
 * submitSaveDraftTicketInviteGuestDesk
 * submit save draft ticket invite guest desk
 * @param {*} argsAll 
 * @param {*} formData 
 * @param {*} panelId 
 * @param {*} panelType 
 * @param {*} tabId 
 * @returns 
 */
const submitSaveDraftTicketInviteGuestDesk = async (argsAll, formData, panelId, panelType, tabId) => {
    let selectedForm = formData.selectedForm ? formData.selectedForm : argsAll.selectedForm;

    const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);
    // validate exceed max size
    if (validateExceedSizeOfFieldTicket(argsAll.fieldListData, argsAll.setFiledListData, fields, argsAll.setErrorMessageHeader)) {
        argsAll.setIsLoading(false);
        return;
    }

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };

    if (formData[Constant.FORM_FILE_UPLOAD_LIST_INPUT_NAME]?.length) {
        uploadFileS3Result = await handleUploadFilesForTicket(
            formData,
            argsAll.setFileUploading,
            argsAll.fileUploadList
        );
    }

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    const requestBody = {
        createTicketRequestDto: {
            orgName: formData.guestOrg ? formData.guestOrg : '',
            projectName: formData.guestProject ? formData.guestProject : '',
            adminEmail: formData.adminMailAdress,
            adminFirstName: formData.adminFirstName,
            adminLastName: formData.adminLastName,
            maxGeneralId: parseInt(formData?.maxGeneralId),
            subDomainInvited: formData?.subDomainInvited,
            corporationOrigin: argsAll.corporationDetail.id,
            createUserId: argsAll.userDetail.id,
            projectOrigin: argsAll.projectInuseDetail.id,
            ticketType: Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT,
            type: selectedForm,
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.DRAFT,
            fields,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),
            ...draftTicketInfo
        },
    };

    const newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        let errList = newTicket?.errors;
        let msgCode = !Utils.isEmptyArray(errList) ? errList[0]?.message : '';
        if (msgCode) {
            argsAll.enqueueSnackbar(buildSnackbarMessage(msgCode), {
                variant: 'error',
                autoHideDuration: 3000,
            });
        }

        argsAll.setIsLoading(false);
        return;
    }

    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_INVITED_QA,
        formId: selectedForm,
        projectTargetId: formData.projectTarget,
        corpTargetId: formData.corporationTarget ? formData.corporationTarget : argsAll.corporationDetail.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);
    
    return newTicket;
}


/**
 * submitSaveDraftTicketExternalDeskRequest
 * @param {*} argsAll 
 * @param {*} formData 
 * @param {*} panelId 
 * @param {*} panelType 
 * @param {*} tabId 
 * @returns 
 */
const submitSaveDraftTicketExternalDeskRequest = async (argsAll, formData, panelId, panelType, tabId) => {
    if (!argsAll.selectedForm ||
        Utils.isEmptyObject(argsAll.externalDeskRequestProject) ||
        !argsAll.externalDeskRequestProject?.value ||
        !argsAll.externalDeskRequestProject?.corporationId
    ) {
        let errObj = {...externalDeskProjectErrObj};
        errObj.helperText = 'COMM01MSG11';
        argsAll.setExternalDeskProjectErr(errObj);
        argsAll.setIsLoading(false);
        return;
    }

    let requestBody = {};
    const fields = await Utils.getCustomFieldValueInFormData(formData, argsAll.fieldListData);
    const statusField = argsAll.fieldListData.find((fieldData) => fieldData.type === Constant.FORM_TYPE.FIELD_WORKFLOW);
    let status = '';
    if(!Utils.isEmptyObject(statusField)){
        status = statusField.fieldId;
    }

    let customer = argsAll.projectInuseDetail.id;

    // External desk request invitation
    let ticketType = Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK;
    let selectedForm = formData.selectedForm ? formData.selectedForm : argsAll.selectedForm;
    let affiliationOrganization = argsAll.externalDeskRequestProject.corporationId;
    let affiliationProject = argsAll.externalDeskRequestProject.value;
    let inviteAndApproveStatus = {};

    formData.corporationTarget = affiliationOrganization;
    formData.projectTarget = affiliationProject;
    inviteAndApproveStatus.invitationFlag = Constant.INVITATION_FLAG.WAITING_APPROVE;
    inviteAndApproveStatus.approveFlag = Constant.APPROVE_FLAG.INPROCESS;

    let uploadFileS3Result = {
        fileListSuccess: [],
        suffixOfAttachments: {},
        listFileError: []
    };
    
    uploadFileS3Result = await handleUploadFilesForTicket(
        formData,
        argsAll.setFileUploading,
        argsAll.fileUploadList
    );

    let draftTicketInfo = {
        isSendDraft: argsAll?.isDraft ? true : false,
        fileUploadedList: copyFileOfTicketDraftTo(argsAll.fileUpdatedList),
        oldDraftTicketId: argsAll?.detailTicket?.id ? argsAll?.detailTicket?.id : ''
    };

    requestBody = {
        createTicketRequestDto: {
            liveOrArchived: Constant.LIVE_OR_ARCHIVED.LIVE,
            public: Constant.TICKET_PUBLIC.DRAFT,
            outline: formData?.outline,
            description: formData?.description,
            createUserId: argsAll.userDetail.id,
            corporationOrigin: argsAll.corporationDetail.id,
            projectOrigin: argsAll.projectInuseDetail.id,
            projectTarget: [affiliationProject],
            corporationTarget: affiliationOrganization,
            ticketType,
            type: selectedForm,
            affiliationOrganization,
            affiliationProject,
            status,
            customer,
            fields,
            fileListSuccess: uploadFileS3Result.fileListSuccess,
            suffixOfAttachments: JSON.stringify(uploadFileS3Result?.suffixOfAttachments),

            // External desk request
            ...inviteAndApproveStatus,
            ...draftTicketInfo
        },
    };

    const newTicket = await saveDraftTicketAPI(argsAll.API, requestBody);
    if (!newTicket?.id) {
        let errList = newTicket?.errors;
        let msgCode = !Utils.isEmptyArray(errList) ? errList[0]?.message : '';
        if (msgCode) {
            argsAll.enqueueSnackbar(buildSnackbarMessage(msgCode), {
                variant: 'error',
                autoHideDuration: 3000,
            });
        }

        argsAll.setIsLoading(false);
        return;
    }
    let dataUpdateLastForm = {
        typeLastTicket: Constant.TYPE_LAST_FORM.LAST_FORM_INVITED_QA,
        formId: selectedForm,
        projectTargetId: formData.projectTarget,
        corpTargetId: formData.corporationTarget ? formData.corporationTarget : argsAll.corporationDetail.id
    }

    await updateUserWorkLastForm(dataUpdateLastForm, argsAll.setUserDetail, argsAll.userDetail);

    return newTicket;
}


/**
 * checkIsDisableButtonDraft
 * @param {*} argsAll 
 */
export const checkIsDisableButtonDraft = (argsAll) => {
    let isDisable = false;

    switch (argsAll.createTicketType) {
        case Constant.TICKET_TYPE.ESCALATION:
        case Constant.TICKET_TYPE.QA:
            if (!argsAll.projectTarget || !argsAll.selectedForm) {
                isDisable = true;
            }
            break;
        case Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT:
            break;
        case Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK:
            if (Utils.isEmptyObject(argsAll.externalDeskRequestProject) || !argsAll.externalDeskRequestProject.value) {
                isDisable = true;
            }
            break;
        default:
            break;
    }
    // Ticket draft not edit
    if ((argsAll.isDraftMode && !argsAll.isEdited) || argsAll.isLoading) {
        isDisable = true;
    }

    // Ticket draft not edit
    if ((argsAll.isDraftMode && !argsAll.isEdited) || argsAll.isLoading) {
        isDisable = true;
    }

    return isDisable;
};


export const checkIsDisableBtnSent = (argsAll) => {
    let isDisable = false
    // check selected create ticket type and select form
    if (
        !argsAll.createTicketType ||
        !argsAll.selectedForm ||
        Utils.isEmptyArray(argsAll.fieldListData) ||
        !Utils.isEmptyObject(argsAll.errorCreateQaTicket)
    ){
        isDisable = true;
    }

    // Check for QA ticket
    if ([Constant.TICKET_TYPE.QA, Constant.TICKET_TYPE.QA, Constant.TICKET_TYPE.QA,Constant.TICKET_TYPE
    .ESCALATION].includes(argsAll.createTicketType) && !argsAll.projectTarget) {
        isDisable = true;
    }

    if (argsAll.createTicketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK && (Utils.isEmptyObject(argsAll.externalDeskRequestProject) || !argsAll.externalDeskRequestProject.value)) {
        isDisable = true;
    }

    // check input all fields required
    if(!isInputAllFieldRequired(argsAll.fieldListData, argsAll.getValuesCreateQaTicket, argsAll.fileUploadList)) {
        isDisable = true;
    }
    return isDisable;
}


/**
 * initDataPanelCreateTicket
 * @param {*} currentPanelInitDataRes 
 * @param {*} argsAll 
 */
export const initDataPanelCreateTicket = (currentPanelInitDataRes, argsAll) => {
    let oldArgsAll = currentPanelInitDataRes.argsAll;
    // File upload
    let fileUploadListOld = oldArgsAll.fileUploadList;
    if (!Utils.isEmptyArray(fileUploadListOld)) {
        argsAll.setFileUploadList(fileUploadListOld);
        argsAll.setValueCreateQaTicket(
            'fileUploadList',
            fileUploadListOld
        );
    }

    // Ticket invite external desk
    if (
        oldArgsAll.externalDeskProjectList &&
        !Utils.isEmptyArray(oldArgsAll.externalDeskProjectList)
    ) {
        argsAll.setExternalDeskProjectList(oldArgsAll.externalDeskProjectList);
    }
    if (
        oldArgsAll.externalDeskRequestProject &&
        !Utils.isEmptyObject(oldArgsAll.externalDeskRequestProject)
    ) {
        argsAll.setExternalDeskRequestProject(oldArgsAll.externalDeskRequestProject);
        argsAll.setOpenExternalDeskList(false);
    }

    // Ticket QA
    if (oldArgsAll.internalHelpDeskList && !Utils.isEmptyArray(oldArgsAll.internalHelpDeskList)) {
        argsAll.setInternalHelpDeskList(oldArgsAll.internalHelpDeskList);
    }
    if (oldArgsAll.externalHelpDeskList && !Utils.isEmptyArray(oldArgsAll.externalHelpDeskList)) {
        argsAll.setExternalHelpDeskList(oldArgsAll.externalHelpDeskList);
    }

    if (oldArgsAll.projectTarget) {
        let currentArgsAll = cloneDeep(argsAll);
        currentArgsAll.internalHelpDeskList = oldArgsAll.internalHelpDeskList;
        currentArgsAll.externalHelpDeskList = oldArgsAll.externalHelpDeskList;
        argsAll.setIsLoading(true);
        submitOnchangeProject(oldArgsAll.projectTarget, currentArgsAll)
            .then(async result => {
                if (oldArgsAll.selectedForm) {
                    await submitOnchangeFormQA(oldArgsAll.selectedForm, argsAll);
                }
                argsAll.setIsLoading(false);
            })
            .catch(err => {
                console.log('initDataPanelCreateTicket err:', err);
                argsAll.setIsLoading(false);
            })
            .finally(() => {
                argsAll.setIsLoading(false);
            });
    }
    
    if (!Utils.isEmptyString(currentPanelInitDataRes?.displayMode) && argsAll?.setDisplayMode) {
        argsAll?.setDisplayMode(currentPanelInitDataRes?.displayMode);
    }

    if (currentPanelInitDataRes?.isEditedData === true && argsAll?.setIsEdited) {
        argsAll?.setIsEdited(currentPanelInitDataRes?.isEditedData);
    }
};

/**
 * 
 * @param {*} argsAll 
 * @param {*} projectTargetSelected 
 */
 const setProjectTargetDraftTicketDetail = async(argsAll) => {
    let ticketDetail = argsAll?.detailTicket;
    let projectTargetSelected = argsAll.draftData.detailTicket.projectTarget[0];
    if(ticketDetail.ticketType === Constant.TICKET_TYPE.INVITATION_GUEST_DESK_PROJECT  || ticketDetail.ticketType === Constant.TICKET_TYPE.REQUEST_EXTERNAL_DESK){
        projectTargetSelected = Constant.EXTERNAL_REQUEST_TYPE.DESK_REQUEST;
    }
    if(!Utils.isEmpty(projectTargetSelected) && !Utils.isEmptyString(projectTargetSelected)){
        await submitOnchangeProject(projectTargetSelected, argsAll, true);
    }
}

/**
 * 
 * @param {*} argsAll 
 */
 const setFormDataDraftTicketDetail = async (argsAll) => {
    let formDetail = Utils.convertJSONDataToObject(argsAll.draftData.formDetail);
    let fieldListData = Utils.convertJSONDataToObject(argsAll.draftData.fieldListData);

    let cloneCurrentPanelInitData = cloneDeep(argsAll.currentPanelInitData);
    let objFormData = cloneCurrentPanelInitData?.formData && !Utils.isEmptyObject(cloneCurrentPanelInitData?.formData) ? cloneCurrentPanelInitData?.formData : {};

    if (!Utils.isEmptyArray(fieldListData)) {
        fieldListData.forEach(field => {
            if (!TmpHiddenSysFieldInTicketDetail.includes(field.sysField)) {
                if (field.type === Constant.FORM_TYPE.FIELD_TAG) {
                    let defaultSelectedTag = [];
                    if (!Utils.isEmpty(field?.defaultValue)) {
                        defaultSelectedTag = field.defaultValue;
                    }
                    objFormData[field.id] = defaultSelectedTag;
                } else {
                    objFormData[field.id] = field.value;
                }
            }
        });
        cloneCurrentPanelInitData.formData = objFormData;
        argsAll.setCurrentPanelInitData(cloneCurrentPanelInitData);
    }

    await submitOnchangeFormQA(formDetail.id, argsAll, true, formDetail, fieldListData);
}

/**
 * First of all, I must keep ticket data when i want to see draft ticket
 * Step 1: I must get selectedProject of ticket (selected 1st)
 * Step 2: I must get form which ticket used. 
 * Step 2.1: I must get formId of ticket
 * Step 2.2: I must get list of form which project in corporation can use (selected 2nd)
 * Step 3: I must keep all data of list fields (must get form data)
 * @param {*} argsAll 
 */
export const renderDraftTicketDetail = async(argsAll) => {
    // let formDetail = Utils.convertJSONDataToObject(argsAll.draftData.formDetail);
    argsAll.setIsLoading(true);
    await setProjectTargetDraftTicketDetail(argsAll); 
    // await submitOnchangeFormQA(formDetail.id, argsAll, true); 
    await setFormDataDraftTicketDetail(argsAll);
    argsAll.setIsLoading(false);
}

export const onSubmitDeleteDraftQaTicket = async(argsAll, panelId, panelType, tabId) => {
    argsAll.setIsLoading(true);
    if (argsAll.isDraft || argsAll.isDraftMode) {
        let ticketId = argsAll.draftTicketData ? argsAll.draftTicketData.detailTicket.id : argsAll.detailTicket.id;
        let {status: currentStatusTicket} = await checkDetailTicket(argsAll.API, ticketId);
        if (currentStatusTicket === Constant.TICKET_DELETED_STATUS.REMOVED) {
            argsAll.setIsOpenPopupError(true);
            return;
        }

        let removeOldTicket = await deleteAllTicketData(argsAll.API, {
            ticketId: ticketId
        });

        argsAll.setIsLoading(false);
        if (!removeOldTicket) {
            argsAll.enqueueSnackbar(buildSnackbarMessage('SYSMSG001'), {
                variant: 'error',
                autoHideDuration: 3000
            });
            return;
        }
        //reload ticketList
        argsAll.reloadTicketListByPanelType({ panelType : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST } );
        
        argsAll.closePanelTab({
            event: null,
            panelType: Utils.getPanelData(panelId, argsAll.panelList).type,
            panelId: panelId,
            tabId: argsAll.tabId
        });
    }

    argsAll.enqueueSnackbar(buildSnackbarMessage('MSG-CM-DELETE-CONTENT-SUCCESSFULLY'), {
        variant: 'success',
        autoHideDuration: 3000
    });
    return true;
}